import { Button, Col, Row, Space, Tree, Typography } from "antd";
import { useCallback, useEffect, useMemo } from "react";
import { BiRefresh } from "react-icons/bi";
import { BsBox, BsFillStickyFill, BsMailbox2 } from "react-icons/bs";
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { useLocation } from 'react-router-dom';
import { IOperationState, ITrayPieceBarCodeList } from '../../../../../model/OperationModel';
import { useOperationStore } from '../../../../../stores/OperationStore';
import { isEmptyCheck } from "../../../../../utils/app-common";
import LoadingModalComponent from "../../../../CommonComponent/LoadingModalComponent";
import { AiOutlineBarcode } from "react-icons/ai";


const BarCodesComponent = () => {

	//const params = useParams();
	const { state } = useLocation() || {};
	const { waybillNo } = state || {};

	const showLine = true,
		showIcon = true,
		showLeafIcon = false

	const { promiseInProgress: pieceBarcodeListPromise } = usePromiseTracker({ area: 'barcode-list-area' })
	const BarCodeList = useOperationStore((state: IOperationState) => state?.BarCodeList);
	const GetBarCodeAction = useOperationStore((state: IOperationState) => state?.GetBarCodeAction);

	const getBarCodeData = useCallback(() => {
		if (!isEmptyCheck(waybillNo)) {
			useOperationStore.setState({ BarCodeList: {} })
			// trackPromise(GetBarCodeAction(('A1010001330')), 'barcode-list-area');
			trackPromise(GetBarCodeAction(waybillNo), 'barcode-list-area');
		}
	}, [GetBarCodeAction, waybillNo])

	useEffect(() => {
		getBarCodeData();
	}, [getBarCodeData, waybillNo])



	const TitleComponent = ({ ipx, trayPieceBarCode }: { trayPieceBarCode: ITrayPieceBarCodeList, ipx: number }) => {
		return (
			<Row gutter={5} justify={'start'} align={'middle'}>
				<Col>
					<Typography.Text>
						{ipx + 1} Piece |
					</Typography.Text>
				</Col>
				<Col>
					<Typography.Text >
						<Space size={5}>
							Piece Barcode :
							<Typography.Text copyable={Boolean(trayPieceBarCode?.pieceBarcode)} mark>
								{trayPieceBarCode?.pieceBarcode}
							</Typography.Text>
						</Space>
					</Typography.Text>
				</Col>
				<Col>
					<Typography.Text>
						| Sample Type : {trayPieceBarCode?.sampleTypeLS} |
					</Typography.Text>
				</Col>
				<Col>
					<Typography.Text>
						Value: {trayPieceBarCode?.mlValue ?? ''}  {trayPieceBarCode?.unitOfMeasure ?? ''}
					</Typography.Text>
				</Col>
			</Row>
		)
	}
	const nodedata = useMemo(() => {
		return BarCodeList?.bookingBoxBarCodeList?.map((data, idx) => {
			const { boxBarcode, pieceCount, bookingTrayList } = data || {};
			return {
				title: `${idx + 1} Box : ${boxBarcode} | Piece : ${pieceCount}`,
				key: { idx },
				icon: <BsMailbox2 size={18} />,
				children: bookingTrayList?.map((bookingTray, itrx) => ({
					title: `${itrx + 1} Tray : ${bookingTray?.trayBarcode} | Piece : ${bookingTray?.pieceCount}`,
					key: `${idx} - ${itrx}`,
					icon: BsFillStickyFill,
					children: bookingTray?.trayPieceBarCodeList?.map((trayPieceBarCode, ipx) => ({
						title: <TitleComponent ipx={ipx} trayPieceBarCode={trayPieceBarCode} />,
						key: `${idx}-${itrx}-${ipx}`,
						icon: BsBox,
					}))
				}))
			}
		});
	}, [BarCodeList])

	if (pieceBarcodeListPromise) {
		return <LoadingModalComponent isLoading={pieceBarcodeListPromise} >
			<Row justify={'center'} align={'middle'} style={{ height: '100%' }}>

			</Row>
		</LoadingModalComponent>
	}



	return (
		<LoadingModalComponent isLoading={pieceBarcodeListPromise}>
			<>
				<Row justify={'end'} style={{ marginBottom: '1rem' }}>
					<Button icon={<BiRefresh size={18} />} onClick={() => getBarCodeData()} htmlType="button"></Button>
				</Row>
				{
					(nodedata?.length) ?
						<Tree
							showLine={showLine ? { showLeafIcon } : false}
							showIcon={showIcon}
							treeData={nodedata}
						/>
						:
						<Row justify={'center'} align={'middle'} style={{ height: '100%' }}>
							<AiOutlineBarcode size={50} />
							<Typography.Text type="secondary" style={{ marginLeft: '1rem' }}>No Barcodes Found</Typography.Text>
						</Row>
				}

			</>
		</LoadingModalComponent>
	)
}

export default BarCodesComponent